module.exports = __webpack_public_path__ + "assets-customer/images/t-shirts-category.png?2fe2a2f8";